import React from "react";
import { BasicDetailsContainer } from "../../../containers";

const BasicDetails = (props) => {
  return <BasicDetailsContainer {...props} />;
};

export default BasicDetails;
